import * as ActionTypes from '../ActionTypes';

export const GetVisitorsAction = (params) => {
    return {
        type: ActionTypes.VISITORS_GET_REQUEST ,
        params
    }
}

export const GetVisitorsDataAction = (params) => {
    return {
        type: ActionTypes.VISITORS_DATA_GET_REQUEST ,
        params
    }
}

export const AddVisitorsAction = (params, callback) => {
    return {
        type: ActionTypes.ADD_VISITORS_REQUEST ,
        params,
        callback
    }
}

export const UpdateVisitorsAction = (params, callback) => {
    return {
        type: ActionTypes.UPDATE_VISITORS_REQUEST ,
        params,
        callback
    }
}
export const UpdateBulkVisitorsAction = (params, callback) => {
    return {
        type: ActionTypes.UPDATE_BULK_VISITORS_REQUEST ,
        params,
        callback
    }
}

export const GetVisitorReasonActions = (params) => {
    return {
        type: ActionTypes.GET_VISITORS_REASON_REQUEST ,
        params
    }
}

// Visitor Management Reason Actions
export const GetVisitorManagementReasonAction = (params) => {
    return {
        type: ActionTypes.VISITOR_MANAGEMENT_REASON_GET_REQUEST,
        params,
    };
};

export const AddVisitorManagementReasonAction = (params) => {
    return {
        type: ActionTypes.VISITOR_MANAGEMENT_REASON_ADD_REQUEST,
        params,
    };
};

export const UpdateVisitorManagementReasonAction = (params) => {
    return {
        type: ActionTypes.VISITOR_MANAGEMENT_REASON_UPDATE_REQUEST,
        params,
    };
};

export const DeleteVisitorManagementReasonAction = (params) => {
    return {
        type: ActionTypes.VISITOR_MANAGEMENT_REASON_DELETE_REQUEST,
        params,
    };
};

// Visitor Management Region Actions
export const GetVisitorManagementRegionAction = (params) => {
    return {
        type: ActionTypes.VISITOR_MANAGEMENT_REGION_GET_REQUEST,
        params,
    };
};

export const AddVisitorManagementRegionAction = (params) => {
    return {
        type: ActionTypes.VISITOR_MANAGEMENT_REGION_ADD_REQUEST,
        params,
    };
};

export const UpdateVisitorManagementRegionAction = (params) => {
    return {
        type: ActionTypes.VISITOR_MANAGEMENT_REGION_UPDATE_REQUEST,
        params,
    };
};

export const DeleteVisitorManagementRegionAction = (params) => {
    return {
        type: ActionTypes.VISITOR_MANAGEMENT_REGION_DELETE_REQUEST,
        params,
    };
};

export const GetVMExtraSettingConfigRequestAction = (params) => {
    return {
        type: ActionTypes.VM_EXTRA_SETTING_GET_REQUEST,
        params,
    };
};
export const UpdateVMExtraSettingConfigRequestAction = (params) => {
    return {
        type: ActionTypes.VM_EXTRA_SETTING_UPDATE_REQUEST,
        params,
    };
};

// VM Org Type Actions
export const GetVMOrgTypeAction = (params) => {
    return {
        type: ActionTypes.VM_ORG_TYPE_GET_REQUEST,
        params,
    };
};

export const UpdateVMOrgTypeAction = (params) => {
    return {
        type: ActionTypes.VM_ORG_TYPE_UPDATE_REQUEST,
        params,
    };
};

// VM Multiple Org Configuration Actions
export const GetVMMultipleOrgConfigurationAction = (params) => {
    return {
        type: ActionTypes.VM_MULTIPLE_ORG_GET_REQUEST,
        params,
    };
};

export const UpsertVMMultipleOrgConfigurationAction = (params) => {
    return {
        type: ActionTypes.VM_MULTIPLE_ORG_UPSERT_REQUEST,
        params,
    };
};

export const DeleteVMMultipleOrgConfigurationAction = (params) => {
    return {
        type: ActionTypes.VM_MULTIPLE_ORG_DELETE_REQUEST,
        params,
    };
};

// VM Pre-Registration Actions
export const GetVMPreRegistrationVisitorAction = (params) => {
    return {
        type: ActionTypes.VM_PRE_REGISTRATION_GET_REQUEST,
        params,
    };
};

export const UpsertVMPreRegistrationVisitorAction = (params, callback) => {
    return {
        type: ActionTypes.VM_PRE_REGISTRATION_UPSERT_REQUEST,
        params,
        callback
    };
};

export const DeleteVMPreRegistrationVisitorAction = (params) => {
    return {
        type: ActionTypes.VM_PRE_REGISTRATION_DELETE_REQUEST,
        params,
    };
};

